
  import { mixins } from "vue-class-component";
  import { ScrollTop } from "@/mixins/utilities";

  export default class ProductRangeView extends mixins(ScrollTop) { }
